import {Component, DestroyRef, inject, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MenuApiService} from '@emm/menu/services/menu-api.service';
import {catchError} from "rxjs/operators";
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";
import {of} from "rxjs";
import {formatFieldName} from '@emm/core/util/string-format.util';

@Component({
    selector: 'emm-view-overrides-dialog',
    templateUrl: './view-overrides-dialog.component.html',
    styleUrls: ['./view-overrides-dialog.component.scss'],
    standalone: false
})
export class ViewOverridesDialogComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    submenu = this.data.selectedSubmenu;
    attribute = this.data.attribute.jsonProperty;
    itemPath = this.data.itemPath;
    effectiveDate = this.data.effectiveDate;
    currentValue = this.data.currentValue;
    location = this.data.location;
    childPath;
    parentPath = `/${this.submenu}/${this.data.itemTag}`;
    overrides;
    formattedOverrides = [];
    displayedColumns = ['key', 'value'];
    loading = true;
    notFound = false;
    attributeDisplayName = 'this attribute';
    inheritedFrom: string;


    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialogRef: MatDialogRef<ViewOverridesDialogComponent>,
        private api: MenuApiService) {
    }

    ngOnInit(): void {
        this.removeSubmenuFromPath();
        // Format the attribute name for display, using jsonProperty as fallback if name is generic
        if (this.data.attribute.name) {
            this.attributeDisplayName = formatFieldName(this.data.attribute.name);
        }
        this.getOverrides();
    }

    closeDialog(): void {
        this.dialogRef.close(false);
    }

    get hasCurrentValueMatch(): boolean {
        return !!this.currentValue && this.formattedOverrides.some(o => o.value === this.currentValue);
    }

    removeSubmenuFromPath() {
        const path = this.itemPath.split('/');
        path.shift();
        path.shift();
        this.childPath = `/${path.join('/')}`;
        return this.childPath;
    }

    async getOverrides() {
        this.api.getAttributeOverrides(this.attribute, this.location, this.submenu, this.childPath, this.effectiveDate)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                catchError((error: HttpErrorResponse) => {
                    if (error.status === HttpStatusCode.NotFound) {
                        this.notFound = true;
                    }
                    this.loading = false;
                    return of(null);
                })
            )
            .subscribe(
            res => {
                if (res) {
                    const keys = [];
                    const values = [];
                    this.inheritedFrom = res.inheritedFrom;
                    Object.keys(res.overrides).forEach(key => {
                        keys.push(key);
                    });
                    Object.values(res.overrides).forEach(value => {
                        values.push(value);
                    });
                    for (let i = 0; i < keys.length; i++) {
                        this.formattedOverrides.push({key: keys[i], value: values[i]});
                    }
                }
                this.loading = false;
            }
        );
        await this.overrides;
    }
}
